import { render } from "./DateTimeWithNote.vue?vue&type=template&id=195d24ed"
import script from "./DateTimeWithNote.vue?vue&type=script&lang=js"
export * from "./DateTimeWithNote.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__